<template>
  <div>
    <div
      class="modal fade"
      id="dropshipDisabled"
      tabindex="-1"
      role="dialog">
      <div
        class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <button
              type="button"
              class="btn-close float-end"
              data-bs-dismiss="modal"
              aria-label="Close">
            </button>
            <h4>
              <i class="fa fa-exclamation-triangle"/>
              Dropship Cart - Checkout Unavailable
            </h4>
            <div class="my-4">
              <span>We are currently working on updating this dropship vendor. We apologize for the inconvenience and appreciate your patience at this time.</span>
            </div>
            <h6 class="mt-2">Please Check Back Later</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

